

import { createSlice } from "@reduxjs/toolkit"

const authSlice = createSlice({
   name: "auth",
   initialState: {
      token: null,
      getTokenLoading: false,
   },
   reducers: {
      getTokenLoading: (state) => {
         state.getTokenLoading = true
      },
      getTokenSuccess: (state, action) => {
         state.token = action.payload
         state.getTokenLoading = false
      },
      getTokenFailure: (state) => {
         state.getTokenLoading = false
      },
   },
})

export const { getTokenLoading, getTokenSuccess, getTokenFailure } =
   authSlice.actions

export default authSlice.reducer